// ONE ROW ID AGAINST ANOTHER (27 Oct 2026, the operator's live bug on b9bec2c6).
//
// A bigint column (admin.chain_transfers.id is bigserial) comes from pg as a STRING, and GET /api/chain spreads the
// row as it came — so a transfer's id is "1689963", while ?row=1689963 read through Number() is 1689963. `===`
// between the two is never true: the rebuilt Chain screen found no row to open and jumped to All with no sheet.
// Compare ids as text: the same id matches whichever side is a number, and null never matches anything.
export const sameId = (a: string | number | null | undefined, b: string | number | null | undefined): boolean =>
  a != null && b != null && String(a) === String(b);
